"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickHandlerNames = void 0;
exports.ClickHandlerNames = [
    "onchange",
    "onclick",
    "oninput",
    "onkeydown",
    "onkeyup",
    "onkeypress",
    "onload",
    "onmouseover",
    "onmouseout",
    "onmouseenter",
    "onmouseover",
    "onmouseout",
    "ontouchcancel",
    "ontouchend",
    "ontouchmove",
    "ontouchstart",
    "onmousedown",
    "onmouseup"
];
//# sourceMappingURL=interfaces.js.map